
import format from "date-fns/format";
import React, { Suspense, useState, useEffect } from "react";
import Drawer from 'react-modern-drawer';
import projectServices from "./projectServices";
import { CommonUtilities } from "../../commonUtils";
import Pagination from "components/Common/newPagination";
import DeleteDialogueBox from "../Common/deleteDialogue";
import cachingMechanisum from "../Common/cachingMechanisum";
 

export default function ProjectSlider(param: any) {

    const [isOpen, setIsOpen] = React.useState(false);
    const toggleDrawer = () => { setIsOpen(!isOpen) }
    const [periodFrom, setPeriodFrom] = useState("")
    const [periodTo, setPeriodTo] = useState("");
    const [defaultPeriod, setDefaultPeriod] = useState(0);

    const [periodPayload, setPeriodPayload] = useState<any>([]);

    let [periodSelectedList, SetperiodSelectedList] = useState<any>([]);

    useEffect(() => {

        var periodListCache = cachingMechanisum.getCachingStorage("SystemPeriod");
        SetperiodSelectedList(periodListCache)
        for (var i = 0; i < (periodListCache)?.length; i++) {
            if ((periodSelectedList)[i]?.periodCurrent === 1) {
                
                setPeriodFrom(format(new Date((periodSelectedList)[i].periodFrom), "MMM dd, yyyy"))
                setPeriodPayload((periodSelectedList)[i])
                setPeriodTo(format(new Date((periodSelectedList)[i].periodTo), "MMM dd, yyyy"))
                setDefaultPeriod(i)
            }

        }
    }, [])

    const periodSelected = (e: any) => {

        if ((e === 1) && ((periodSelectedList.length) !== (defaultPeriod - 1))) {
            /// console.log(  format(new Date((periodSelectedList)[(defaultPeriod-1)].periodFrom), "dd MMM yyyy") );
            setPeriodFrom(format(new Date((periodSelectedList)[(defaultPeriod - 1)].periodFrom), "dd MMM yyyy"));

            /// console.log(  format(new Date((periodSelectedList)[(defaultPeriod-1)].periodTo), "dd MMM yyyy") );
            setPeriodTo(format(new Date((periodSelectedList)[(defaultPeriod - 1)].periodTo), "dd MMM yyyy"));
            setDefaultPeriod((defaultPeriod - 1));

        } else if ((e === 0) && ((periodSelectedList.length) !== (defaultPeriod + 1))) {
            // console.log(  format(new Date((periodSelectedList)[(defaultPeriod+1)].periodFrom), "dd MMM yyyy") );
            setPeriodFrom(format(new Date((periodSelectedList)[(defaultPeriod - 1)].periodFrom), "dd MMM yyyy"));

            // console.log(  format(new Date((periodSelectedList)[(defaultPeriod+1)].periodTo), "dd MMM yyyy") );
            setPeriodTo(format(new Date((periodSelectedList)[(defaultPeriod + 1)].periodTo), "dd MMM yyyy"));
            setDefaultPeriod((defaultPeriod + 1));
        }

    }

    const [paymentIndicator, initPaymentIndicator] = useState<any[]>([]);
    const [paymentIndicatorRow, initPaymentIndicatorRow] = useState(0);
    let [paymentIndicatorHeader, initPaymentIndicatorHeader] = useState<any[]>([]);
    let [paymentIndicatorDisplay, initPaymentIndicatorDisplay] = useState<any[]>([]);
    const [Confirm, setConfirm] = useState(0);
    const [DeleteRecord, setDeleteRecord] = useState(0);
    let [RecordDelete, setRecordDelete] = useState<any>([]);

    const Data: any = {
        pageSize: 10,
        pageNumber: 1
    }

    const apiCall = () => {
        var indicatorCode = 'payments'
        if (param.type === "payment") {
            indicatorCode = 'payments'
        } else if (param.type === "Earnings") {
            indicatorCode = 'Earnings';
        } else if (param.type === "costs") {
            indicatorCode = 'costs';
        } else if (param.type === "period_balance") {
            indicatorCode = 'period_balance';
        } else if (param.type === "adjustments") {
            indicatorCode = 'adjustments';
        }

        if (param.type !== "totalProject") {
            projectServices.paymentIndicator({
                "export": 0,
                "indicatorCode": indicatorCode,
                "pageNumber": Number(Data.pageNumber),
                "pageSize": Number(Data.pageSize),
                "period": Number(format(new Date(periodPayload.periodTo), "yyyyMMdd")),
                "projectCode": param.data.projectCode
            })
                .then((res) => {
                    initPaymentIndicator(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
                    paymentIndicatorHeader = [];
                    paymentIndicatorDisplay = []
                    initPaymentIndicatorRow(res.totalRows)
                    Object.entries(res.headers.display).forEach(([key, value]) => { paymentIndicatorHeader.push(value) });
                    Object.entries(res.headers.original).forEach(([key, value]) => { paymentIndicatorDisplay.push(value) });
                    initPaymentIndicatorDisplay(paymentIndicatorDisplay)
                    initPaymentIndicatorHeader(paymentIndicatorHeader)
                })
        }
    }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        apiCall()
    }

    const exportData = () => {
        var indicatorCode = 'payments'
        if (param.type === "payment") {
            indicatorCode = 'payments'
        } else if (param.type === "Earnings") {
            indicatorCode = 'Earnings';
        } else if (param.type === "costs") {
            indicatorCode = 'costs';
        } else if (param.type === "period_balance") {
            indicatorCode = 'period_balance';
        } else if (param.type === "adjustments") {
            indicatorCode = 'adjustments';
        }

        projectServices.paymentIndicatorExport({
            "export": 1,
            "indicatorCode": indicatorCode,
            "pageNumber": 1,
            "pageSize": 10000000,
            "period": Number(format(new Date(periodPayload.periodTo), "yyyyMMdd")),
            "projectCode": param.data.projectCode
        }).then(() => { apiCall(); })

    }

    const Confirmation = (e: any) => {

        if (e === 1) {
            projectServices.recalcContractPayment({ "Period": periodPayload.periodDesc })
        }
        setConfirm(0);
        apiCall();
    }

    const DeleteConfirmation = (e: any) => {
        if (e === 1) {
            projectServices.deletePayment({
                "contractrefnum": RecordDelete.contractRefNum,
                "periodnum": RecordDelete.periodNum
            }, { "paymentId": RecordDelete.paymentId })
        }
        setDeleteRecord(0);
        apiCall();
    }


    const [expandlist, setExpand] = useState(0);
    let [expansion, initexpansion] = useState<any>([]);

    let [IndicatorLevel2Header, initIndicatorLevel2Header] = useState<any[]>([]);
    let [IndicatorLevel2Display, initIndicatorLevel2Display] = useState<any[]>([]);
    const [IndicatorLevel2, initIndicatorLevel2] = useState<any[]>([]);
    const [IndicatorLevel2Row, initIndicatorLevel2Row] = useState(0);

    var levelObj = {
        contractRefNum: '',
        export: 0,
        indicatorCode: param.type,
        kType: '',
        pageNumber: 1,
        pageSize: 10,
        period: 1,
        productCode: ''
    }

    const expand = (e: any) => {
        levelObj.contractRefNum = e.assocCont;
        levelObj.kType = e.salesArea;
        levelObj.productCode = e.product;
        levelObj.period = Number(format(new Date(periodPayload.periodTo), "yyyyMMdd"));

        console.log(e)

        if (param.type === "Earnings") {
            var tempOb = { kRegion: e.kRegion }
            levelObj = { ...levelObj, ...tempOb };
        }

        if (expansion.product === e.product) {
            initexpansion([])
            setExpand(0)
        } else {
            projectServices.indicatorLevel2(levelObj).then((res) => {
                initIndicatorLevel2(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
                IndicatorLevel2Header = [];
                IndicatorLevel2Display = []
                initIndicatorLevel2Row(res.totalRows)
                Object.entries(res.headers.display).forEach(([key, value]) => { IndicatorLevel2Header.push(value) });
                Object.entries(res.headers.original).forEach(([key, value]) => { IndicatorLevel2Display.push(value) });
                initIndicatorLevel2Display(IndicatorLevel2Display)
                initIndicatorLevel2Header(IndicatorLevel2Header)

            })
            initexpansion([])
            initexpansion(e)
            setExpand(1)
        }
        console.log(expansion)

    }

    const ExportLevel2 = (e: any) => {
        console.log("call")
        var levelObj = {
            contractRefNum: e.product,
            export: 1,
            indicatorCode: param.type,
            kType: e.salesArea,
            pageNumber: 1,
            pageSize: 10000000,
            period: Number(format(new Date(periodPayload.periodTo), "yyyyMMdd")),
            productCode: e.product
        }

        if (param.type === "Earnings") {
            var tempOb = { kRegion: e.kRegion }
            levelObj = { ...levelObj, ...tempOb };
        }

        projectServices.indicatorLevel2Export(levelObj)
    }

    const handleIndicatorLevel2 = (e: any) => {
        console.log(e)
        var levelObj = {
            contractRefNum: expansion.assocCont,
            export: 0,
            indicatorCode: param.type,
            kType: expansion.salesArea,
            pageNumber: e.pageNumber,
            pageSize: e.pageSize,
            period: Number(format(new Date(periodPayload.periodTo), "yyyyMMdd")),
            productCode: e.product
        }

        if (param.type === "Earnings") {
            var tempOb = { kRegion: e.kRegion }
            levelObj = { ...levelObj, ...tempOb };
        }

        projectServices.indicatorLevel2(levelObj).then((res) => {
            initIndicatorLevel2(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
            IndicatorLevel2Header = [];
            IndicatorLevel2Display = []
            initIndicatorLevel2Row(res.totalRows)
            Object.entries(res.headers.display).forEach(([key, value]) => { IndicatorLevel2Header.push(value) });
            Object.entries(res.headers.original).forEach(([key, value]) => { IndicatorLevel2Display.push(value) });
            initIndicatorLevel2Display(IndicatorLevel2Display)
            initIndicatorLevel2Header(IndicatorLevel2Header)

        })
    }

    return (

        <div >

            {!(param.up) && <span className="pts pull-right" onClick={() => { setIsOpen(!isOpen); apiCall() }}>...</span>}
            {(param.up === true) && <span className="pts pull-right" onClick={() => { setIsOpen(!isOpen); apiCall() }}> {param.value}</span>}

            <Drawer
                open={isOpen}
                direction='right'
                className='react-drawer-left full-height-vh allowHscroll' style={{ width: "100%", height: "100%" }}>
                <div className="ws-7 box pull-right" style={{ minHeight: "680px" }}>

                    {(() => {

                        if (param.type === "totalProject") {
                            return (
                                <>
                                    <div className="box-header">
                                        <a onClick={() => periodSelected(1)} className="btn-xs btn-icon icon-btn primary pull-left"><i className="icon-arrow-left"></i> </a>
                                        <h2 className="ml pull-left mt">Period {periodFrom} - {periodTo}</h2>
                                        <a onClick={() => periodSelected(0)} className="btn-xs btn-icon icon-btn primary pull-left"><i className="icon-arrow-right"></i> </a>
                                        <i className="icon-close pull-right ptl" onClick={() => setIsOpen(!isOpen)}></i>
                                    </div>
                                </>
                            )
                        }

                        if (param.type === "payments" || param.type === "Earnings" || param.type === "costs" || param.type === "period_balance" || param.type === "adjustments") {

                            return (<div>
                                <div className="box-header">
                                    {(param.type !== "period_balance") && <h2 className="ml pull-left mt">Indicator {param.type} details [ {paymentIndicatorRow} Row(s) ]</h2>}
                                    {(param.type === "period_balance") && <h2 className="ml pull-left mt">{"period Balance"} </h2>}
                                    <i className="icon-close pull-right ptl" onClick={() => setIsOpen(!isOpen)}></i>
                                </div>

                                <div className="box-content">

                                    {paymentIndicatorRow !== 0 && <div className="table-responsive allowHscroll allowVscroll">
                                        <table className="box table allowHscroll ">
                                            <thead>
                                                <tr className="forceSingleLine">
                                                    {(param.type !== "payments") && (param.type !== "period_balance") && <th > </th>}
                                                    {
                                                        paymentIndicatorHeader.map(value => (
                                                            <th>{value}</th>
                                                        ))
                                                    }

                                                    {(param.type === "payments") && <th > Operation</th>}
                                                </tr>
                                            </thead>

                                            <tbody>

                                                {
                                                    paymentIndicator.map(values => (<>
                                                        <tr className="forceSingleLine">
                                                            {(param.type !== "payments") && (param.type !== "period_balance") && <td ><a className="btn btn-xs icon-btn primary" onClick={() => expand(values)}>
                                                                {(param.type === 'Earnings' ? (expansion.product === values.product) : param.type === 'costs' ? (expansion.assocCont === values.assocCont) : false) && <i className="icon-arrow-up"></i>}
                                                                {!(param.type === 'Earnings' ? (expansion.product === values.product) : param.type === 'costs' ? (expansion.assocCont === values.assocCont) : false) && <i className="icon-arrow-down"></i>}</a> </td>}
                                                            {
                                                                paymentIndicatorDisplay.map(value => (
                                                                    <td >{values[value]} </td>
                                                                ))

                                                            }
                                                            {(param.type === "payments") && <td><button className="icon-btn delete" onClick={() => { setDeleteRecord(1); setRecordDelete(values) }}><i className="icon-trashcan"></i></button> </td>}

                                                        </tr>

                                                        {(param.type === 'Earnings' ? (expansion.product === values.product) : param.type === 'costs' ? (expansion.assocCont === values.assocCont) : false) &&
                                                            <tr>
                                                                <td colSpan={(paymentIndicatorHeader.length) + 1}>
                                                                    {(IndicatorLevel2Row > 0) && <table>
                                                                        <thead>
                                                                            <tr className="forceSingleLine">
                                                                                {
                                                                                    IndicatorLevel2Header.map(value => (
                                                                                        <th>{value}</th>
                                                                                    ))
                                                                                }
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                IndicatorLevel2.map(values => (
                                                                                    <>
                                                                                        <tr className="forceSingleLine">
                                                                                            {
                                                                                                IndicatorLevel2Display.map(value => (
                                                                                                    <td >{values[value]} </td>
                                                                                                ))
                                                                                            }
                                                                                        </tr> </>
                                                                                ))
                                                                            }
                                                                        </tbody>
                                                                    </table>}

                                                                    {(IndicatorLevel2Row > 0) && <button className="icon-btn info btn-sm pull-right mtxl" onClick={() => ExportLevel2(expansion)}>
                                                                        <i className="fa fa-download"></i> Export Detail
                                                                    </button>}

                                                                    {
                                                                        (IndicatorLevel2Row === 0) && <div> <span className="alert alert-success ws-12 text-center">No data Available</span> </div>
                                                                    }

                                                                    {
                                                                        (() => {
                                                                            if (IndicatorLevel2Row > 1 && IndicatorLevel2Row > 10) {
                                                                                return  <Pagination onPageChange={handleIndicatorLevel2} totalRow={IndicatorLevel2Row} />
                                                                            }

                                                                        })()
                                                                    }
                                                                </td>
                                                            </tr>}

                                                    </>
                                                    ))
                                                }

                                            </tbody>

                                        </table>
                                    </div>}

                                    {
                                        (() => {
                                            if (paymentIndicatorRow > 1 && paymentIndicatorRow > 10) {
                                                return  <Pagination onPageChange={handleNameOnChange} totalRow={paymentIndicatorRow} />
                                            }

                                        })()
                                    }

                                    {paymentIndicatorRow === 0 &&
                                        <div> <span className="alert alert-success ws-12 text-center">No data Available</span> </div>
                                    }

                                </div>

                                <div className="ws-12 ptl">
                                    {((param.type === "payments") || (param.type === "adjustments")) && <button className="icon-btn edit pull-right" onClick={() => setConfirm(1)}><i className="fa fa-calculator"></i>Calculate</button>}
                                    <a className="icon-btn delete pull-right" onClick={() => setIsOpen(!isOpen)}>Close </a>
                                    {paymentIndicatorRow !== 0 && <button className="icon-btn info pull-right" onClick={() => exportData()}><i className="fa fa-download"></i> Export Summary</button>}

                                </div>

                                {
                                    (() => {
                                        if (Confirm && Confirm === 1) {
                                            return <DeleteDialogueBox param={true} message={"perform this calculation?"} onChange={Confirmation} />
                                        }
                                    })()
                                }

                                {
                                    (() => {
                                        if (DeleteRecord && DeleteRecord === 1) {
                                            return <DeleteDialogueBox param={true} message={" delete payment for contractRefNum: " + RecordDelete.contractRefNum + "?"} onChange={DeleteConfirmation} />
                                        }
                                    })()
                                }


                            </div>)
                        }

                    })()

                    }
                </div>
            </Drawer>
        </div>
    )
}